// extracted by mini-css-extract-plugin
module.exports = {"root":"SharePopover_root__2n35K","top":"SharePopover_top__3wWiD","bottom":"SharePopover_bottom__2buac"};